import Skeleton from "react-loading-skeleton";

export default function Subtitle({ text }) {
    return (
        <h4 className="esc-ii-capitalize esc-ii-mt-1.5 esc-ii-font-montserrat esc-ii-text-base esc-ii-font-semibold lg:esc-ii-text-lg lg:esc-ii-mt-3">
            {text || (
                <>
                    <span className="lg:esc-ii-hidden">
                        <Skeleton count={2} />
                    </span>
                    <span className="esc-ii-hidden lg:esc-ii-block">
                        <Skeleton />
                    </span>
                </>
            )}
        </h4>
    );
}
